import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "./Dashboard/hooks/useNotifications";

const ViewAllNotices = () => {
    const navigate = useNavigate();

    const { notifications, loading: loadingNotifications, handleNotificationClick } = useNotifications("All");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = notifications.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(notifications.length / itemsPerPage);

    return (
        <div className="container mt-5 mb-5">
            <h3 style={{ color: "#3c3970", marginBottom: "30px", fontWeight: "600" }}>सूचनाएं/समाचार</h3>

            {loadingNotifications ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    {currentItems.map((notice, idx) => (
                        <div
                            key={notice.id || idx}
                            onClick={() => handleNotificationClick(notice)}
                            className="d-flex align-items-center justify-content-between p-3 mb-2 notice-item"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                            }}
                            title={notice.title_Hindi || "No Title Available"}
                        >
                            <div className="d-flex align-items-center">
                                <span
                                    style={{
                                        display: "inline-block",
                                        backgroundColor: "#3c3970",
                                        color: "white",
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        fontWeight: "bold",
                                        marginRight: "16px",
                                        fontSize: "12px",
                                        minWidth: "90px",
                                        textAlign: "center",
                                    }}
                                >
                                    {notice.created ? moment(notice.created).format("DD MMM YYYY") : "N/A"}
                                </span>
                                <span style={{ fontSize: "15px", fontWeight: "500", color: "#333" }}>
                                    {notice.title_Hindi || "No Title Available"}
                                </span>
                            </div>
                            <div>
                                <i className="bi bi-chevron-right" style={{ color: "#3c3970", fontSize: "18px" }}></i>
                            </div>
                        </div>
                    ))}

                    {/* Pagination */}
                    <nav className="mt-4">
                        <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage((p) => p - 1)}>पिछला</button>
                            </li>

                            {Array.from({ length: totalPages }, (_, i) => (
                                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}

                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage((p) => p + 1)}>अगला</button>
                            </li>
                        </ul>
                    </nav>
                </>
            )}

            <style>
                {`
          .notice-item:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }
          .pagination .page-item .page-link {
            border-radius: 50% !important;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 4px;
          }
          .pagination .page-item.active .page-link {
            background-color: #3c3970 !important;
            border-color: #3c3970 !important;
            color: white !important;
          }
        `}
            </style>
        </div>
    );
};

export default ViewAllNotices;
